import env from './../../environments/environment'

const SUBSITE_LOGO_SRC = `https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/{SUBSITE_LOGO}?alt=media`

function getSubsiteLogo(logoOrSite) {
  const logo = logoOrSite && typeof logoOrSite === 'object' ? logoOrSite?.s_logo : logoOrSite

  const path = `${logo === null || typeof logo === 'undefined' ? '' : logo}`.trim()
  if (!path) return false

  return SUBSITE_LOGO_SRC.replace('{SUBSITE_LOGO}', encodeURIComponent(decodeURIComponent(path)))
}

export { getSubsiteLogo }
